var dontRemindMe = false;

function setUpFileExpirationWarning() {
    setInterval(function () {
        if (dontRemindMe === false) {
            _toggleExpirationWarning();
        }
    }, 1800000);
}

var _toggleExpirationWarning = function () {
    if ($('#expirationWarning').hasClass('hidden')) {
        $('#expirationWarning').toast('show');
        $('#expirationWarning').toggleClass('hidden');
    }
};

var _hideExpirationWarning = function () {
    $('#expirationWarning').toast('hide');
    $('#expirationWarning').addClass('hidden');
};

$('#dismissExpirationWarning').on('click', function () {
    _hideExpirationWarning();
});

$('#dontRemindMeExpirationWarning').on('click', function () {
    _hideExpirationWarning();
    setDontRemindMe();
});

$('.save-as-btn').on('click', function () {
    _hideExpirationWarning();
    setDontRemindMe();
});

function setDontRemindMe() {
    dontRemindMe = true;
}

export { setUpFileExpirationWarning };
